import React from 'react';
import { Typography } from '../../../Typography';
import { formatDate } from '../../../../utils/utils';

export function DateCell({ value }) {
  return <Typography variant="body2">{formatDate(value) || '-'}</Typography>;
}
